
// import {
//     Button, MenuItem, Paper, TextField, Typography, FormControl,
//     RadioGroup, FormLabel, FormControlLabel, Radio
// } from '@mui/material';
// import { useState } from 'react';
// import api from '../../../services/api';
// import LoadingBackdrop from "../../../load/loadingBackdrop";
// import { useSelector } from 'react-redux';
// import ImageNoticiaEdit from './imageNoticiaEdit';
// import { IconButton } from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';

// import Editor from '../../../ckeditor/editor';
// import ViewNoticia from '../../../pages/home/noticias/viewNoticia';
// // import RegisterAccess from '../../../utils/registerAccess';

// const CreateNoticia = (props) => {
//     const [noticia, setNoticia] = useState(props?.noticia)
//     const [open, setOpen] = useState(false)
//     const user = useSelector(state => state.account.user);
//     const [Preview, setPreview] = useState(false)

//     // console.log(noticia)

//     function HandleChange(e) {
//         e.target.files ?
//             setNoticia({ ...noticia, [e.target.name]: e.target.files[0] })
//             :
//             setNoticia({ ...noticia, [e.target.name]: e.target.value })
//     }

//     async function HandleCreateNoticia() {
//         const formData = new FormData();
//         formData.append('userId', user._id);
//         formData.append('titulo', noticia?.titulo ?? '');
//         formData.append('subTitulo', noticia?.subTitulo ?? '');
//         formData.append('imagem', noticia?.imagem);
//         formData.append('anexo', noticia?.anexo);
//         formData.append('categoria', noticia?.categoria ?? '');
//         formData.append('fonte', noticia?.fonte ?? '');
//         formData.append('link', noticia?.link ?? '');
//         formData.append('conteudo', noticia?.conteudo ?? '');
//         formData.append('seccao', noticia?.seccao);
//         formData.append('destaque', true);
//         formData.append('status', 'Activo');

//         setOpen(true)
//         props.seterrorMessage('')
//         props.setMessage('')

//         props?.noticia ?
//             // EDITANDO UMA NOTICIA
//             await api.put('/noticia/edit', { ...noticia, 'userId': user._id, 'noticiaId': props.noticia._id })
//                 .then(res => {
//                     setOpen(false)
//                     // console.log(res)
//                     props.setMessage(res.data.msg)
//                     props.setEditarNoticia(false)
//                 }).catch(error => {

//                     // props.seterrorMessage(error.response.data.message)
//                     setOpen(false)
//                     // console.log(error)
//                 })
//             :
//             // CRIANDO UMA NOVA NOTICIA 
//             await api.post('/noticia/create', formData)
//                 .then(res => {
//                     setOpen(false)
//                     // console.log(res)
//                     props.setMessage(res.data.msg)
//                     props.setCreateNoticia(false)
//                 }).catch(error => {

//                     props.seterrorMessage(error.response.data.message)
//                     setOpen(false)
//                     // console.log(error)
//                 })
//     }


//     return (
//         <>
//             {/* <RegisterAccess page={'Criar noticia'}/> */}
//             <LoadingBackdrop open={open} text={'A criar notícia. Aguarde!'} />

//             {!Preview ?
//                 <>
//                     <div>
//                         <Typography align='center' variant="subtitle1" style={{ fontSize: 20 }}>
//                             {props.title}
//                         </Typography>
//                         <br />

//                         <FormControl>
//                             <RadioGroup
//                                 row
//                                 style={{ alignItems: 'center', }}
//                             >
//                                 <FormLabel style={{ marginRight: 10 }} id="destaque">Tipo de publicação:</FormLabel>
//                                 <FormControlLabel name="seccao" value={'Notícia'} control={<Radio />} label="Notícia" onClick={HandleChange} />
//                                 <FormControlLabel name="seccao" value={'Destaque'} control={<Radio />} label="Destaque" onClick={HandleChange} />
//                             </RadioGroup>
//                         </FormControl>

//                         {noticia?.seccao === 'Destaque' &&
//                             <div >
//                                 <label>Anexar despacho</label> <br />
//                                 <input accept="application/pdf" type="file" name="anexo" id="ficheiros2" onChange={HandleChange} />
//                             </div>
//                         }
//                         <br />
//                         <br />

//                         {props?.noticia
//                             ?
//                             <ImageNoticiaEdit foto={props.noticia.imagem} noticiaId={props.noticia._id} setEditarNoticia={props.setEditarNoticia} />
//                             :
//                             <Paper style={{ border: '1px dashed #3e3d3f' }}>
//                                 <label htmlFor="imagem" style={{ cursor: 'pointer', textAlign: 'center' }}>
//                                     {noticia?.imagem ?

//                                         <img src={props?.noticia ? props.noticia.imagem : URL.createObjectURL(noticia.imagem)} alt="Imagem" width="100%" title="alterar imagem.." />
//                                         :
//                                         <Typography align="center" variant='body2' style={{ padding: 20 }}>
//                                             Imagem: 1000x650px - Resolução: 72px
//                                         </Typography>
//                                     }
//                                     <input accept="image/png, image/jpg, image/jpeg" type="file" name="imagem" id="imagem" style={{ display: 'none' }} onChange={HandleChange} />
//                                 </label>
//                             </Paper>
//                         }

//                         <TextField
//                             margin='dense'
//                             type="text"
//                             required
//                             label="Titulo"
//                             fullWidth
//                             size="small"
//                             name="titulo"
//                             variant="outlined"
//                             onChange={HandleChange}
//                             defaultValue={noticia?.titulo}
//                         />

//                         <TextField
//                             margin='dense'
//                             type="text"
//                             label="Subtitulo"
//                             fullWidth
//                             size="small"
//                             name="subTitulo"
//                             variant="outlined"
//                             onChange={HandleChange}
//                             defaultValue={noticia?.subTitulo}
//                         />

//                         <TextField
//                             margin='dense'
//                             type="text"
//                             label="Categoria"
//                             select
//                             fullWidth
//                             size="small"
//                             name="categoria"
//                             variant="outlined"
//                             onChange={HandleChange}
//                             defaultValue={noticia?.categoria || props.noticia?.categoria || ''}
//                         >
//                             <MenuItem key="A" value="ANGOLA">
//                                 ANGOLA
//                             </MenuItem>
//                             <MenuItem key="armed" value="ARMED">
//                                 ARMED
//                             </MenuItem>
//                             <MenuItem key="oms" value="OMS">
//                                 OMS
//                             </MenuItem>
//                             <MenuItem key="s" value="SOCIEDADE">
//                                 SOCIEDADE
//                             </MenuItem>
//                             <MenuItem key="c" value="DESPORTO">
//                                 DESPORTO
//                             </MenuItem>
//                             <MenuItem key="d" value="POLÍTICA">
//                                 POLÍTICA
//                             </MenuItem>
//                             <MenuItem key="M" value="MUNDO">
//                                 MUNDO
//                             </MenuItem>
//                             <MenuItem key="r" value="REPORTAGEM">
//                                 REPORTAGEM
//                             </MenuItem>
//                             <MenuItem key="o" value="OUTROS">
//                                 OUTROS
//                             </MenuItem>
//                         </TextField>

//                         <TextField
//                             margin='dense'
//                             type="text"
//                             label="Fonte da notícia"
//                             fullWidth
//                             size="small"
//                             name="fonte"
//                             variant="outlined"
//                             onChange={HandleChange}
//                             defaultValue={noticia?.fonte}
//                         />

//                         <TextField
//                             margin='dense'
//                             type="url"
//                             label="Link da fonte"
//                             fullWidth
//                             size="small"
//                             name="link"
//                             variant="outlined"
//                             onChange={HandleChange}
//                             defaultValue={noticia?.link}
//                         />
//                         <br />
//                     </div>

//                     {/* EDITOR DE TEXTO CKEditor*/}
//                     <Editor
//                         setEditorData={setNoticia}
//                         editorData={noticia?.conteudo}
//                     />

//                     <div align='right'>
//                         {/* FORM PARA PARA DESCATAR OU NAO A NOTICIA */}
//                         {/* <FormControl>
//                             <RadioGroup
//                                 row
//                                 style={{ alignItems: 'center' }}
//                             >
//                                 <FormLabel style={{ marginRight: 10 }} id="destaque">Destacar </FormLabel>
//                                 <FormControlLabel name="destaque" value={false} control={<Radio />} label="Não" onClick={HandleChange} />
//                                 <FormControlLabel name="destaque" value={true} control={<Radio />} label="Sim" onClick={HandleChange} />
//                             </RadioGroup>
//                         </FormControl> */}

//                         {/* FORM PARA APLICAR STATUS DE PUBLICAR OU GUARDAR A NOTICIA */}
//                         <br />
//                         <FormControl>
//                             <RadioGroup
//                                 row
//                                 style={{ alignItems: 'center' }}
//                             >
//                                 <FormLabel style={{ marginRight: 10 }} id="status">Status </FormLabel>
//                                 <FormControlLabel name="status" value={'Activo'} control={<Radio />} label="Publicar" onClick={HandleChange} />
//                                 <FormControlLabel name="status" value={'Inactivo'} control={<Radio />} label="Não Publicar" onClick={HandleChange} />
//                             </RadioGroup>
//                         </FormControl>
//                         <br />
//                         <br />
//                         <Button color='error' style={{ marginRight: 10 }}  onClick={() => { props?.noticia ? props.setEditarNoticia(false) : props.setCreateNoticia(false); props.setTitle('Criação') }}>
//                             Cancelar
//                         </Button>
//                         <Button style={{ marginRight: 10 }} variant="contained" onClick={() => setPreview(true)}>
//                             Preview
//                         </Button>
//                         <Button disabled={(!noticia?.imagem || !noticia?.seccao)} style={{ backgroundColor: '#85287e' }} variant="contained" onClick={HandleCreateNoticia}>
//                             Salvar
//                         </Button>
//                     </div>
//                 </>

//                 :
//                 //  PREVIEW 
//                 <div >
//                     <Typography variant="subtitle1" style={{ fontSize: 20, margin: 5 }}>
//                         <IconButton size='small' color='error' style={{ marginRight: 10 }} onClick={() => setPreview(false)}>
//                             <CloseIcon />
//                         </IconButton>
//                         Preview
//                     </Typography>
//                     {/* <Divider /> */}

//                     <ViewNoticia preview={noticia} criacao={true} />
//                 </div>
//             }
//         </>
//     );
// }

// export default CreateNoticia;


import {
    Alert,
    Box,
    Button,
    Card,
    Chip,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';

import {
    ArrowBack,
    Close,
    CloudUpload,
    Image,
    Link as LinkIcon,
    Preview,
    Public,
    Save,
    Article,
} from '@mui/icons-material';

import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import api from '../../../services/api';

import LoadingBackdrop from "../../../load/loadingBackdrop";

import ImageNoticiaEdit from './imageNoticiaEdit';

import Editor from '../../../ckeditor/editor';

import ViewNoticia from '../../../pages/home/noticias/viewNoticia';

const categorias = [
    'ANGOLA',
    'ARMED',
    'OMS',
    'SOCIEDADE',
    'DESPORTO',
    'POLÍTICA',
    'MUNDO',
    'REPORTAGEM',
    'OUTROS',
];

export default function CreateNoticia(props) {

    const user = useSelector(
        state => state.account.user
    );

    const [loading, setLoading] = useState(false);

    const [preview, setPreview] = useState(false);

    const [error, setError] = useState('');

    const [success, setSuccess] = useState('');

    const [noticia, setNoticia] = useState({

        titulo:
            props?.noticia?.titulo || '',

        subTitulo:
            props?.noticia?.subTitulo || '',

        categoria:
            props?.noticia?.categoria || '',

        fonte:
            props?.noticia?.fonte || '',

        link:
            props?.noticia?.link || '',

        conteudo:
            props?.noticia?.conteudo || '',

        imagem:
            props?.noticia?.imagem || '',

        anexo:
            props?.noticia?.anexo || '',

        seccao:
            props?.noticia?.seccao || 'Notícia',

        status:
            props?.noticia?.status || 'Activo',

        destaque:
            props?.noticia?.destaque || true,

    });

    const imagemPreview = useMemo(() => {

        if (!noticia?.imagem) {
            return null;
        }

        if (typeof noticia.imagem === 'string') {
            return noticia.imagem;
        }

        return URL.createObjectURL(
            noticia.imagem
        );

    }, [noticia?.imagem]);

    const handleChange = (e) => {

        const { name, value, files } =
            e.target;

        if (files) {

            setNoticia((prev) => ({
                ...prev,
                [name]: files[0]
            }));

            return;
        }

        setNoticia((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {

        try {

            setLoading(true);

            setError('');
            setSuccess('');

            const formData = new FormData();

            formData.append(
                'userId',
                user?._id
            );

            Object.keys(noticia).forEach((key) => {

                if (
                    noticia[key] !== undefined &&
                    noticia[key] !== null
                ) {
                    formData.append(
                        key,
                        noticia[key]
                    );
                }
            });

            if (props?.noticia) {

                await api.put(
                    '/noticia/edit',
                    {
                        ...noticia,
                        userId: user?._id,
                        noticiaId:
                            props?.noticia?._id
                    }
                );

                setSuccess(
                    'Notícia actualizada com sucesso.'
                );

                props?.setEditarNoticia(false);

            } else {

                await api.post(
                    '/noticia/create',
                    formData
                );

                setSuccess(
                    'Notícia criada com sucesso.'
                );

                props?.setCreateNoticia(false);
            }

        } catch (err) {

            console.log(err);

            setError(
                err?.response?.data?.message ||
                'Erro ao salvar notícia.'
            );

        } finally {

            setLoading(false);
        }
    };

    const fecharFormulario = () => {

        props?.noticia
            ? props?.setEditarNoticia(false)
            : props?.setCreateNoticia(false);
    };

    return (
        <>

            <LoadingBackdrop
                open={loading}
                text="A processar notícia..."
            />

            {!preview ? (

                <Box>

                    {/* HEADER */}
                    <Card
                        elevation={0}
                        sx={{
                            mb: 4,
                            borderRadius: 5,
                            p: 4,
                            background:
                                'linear-gradient(135deg,#85287e 0%,#5b1b8d 100%)',
                            color: '#fff',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >

                        <Box
                            sx={{
                                position: 'absolute',
                                width: 250,
                                height: 250,
                                borderRadius: '50%',
                                background:
                                    'rgba(255,255,255,.08)',
                                right: -70,
                                top: -70,
                            }}
                        />

                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            flexWrap="wrap"
                            gap={2}
                        >

                            <Box>

                                <Typography
                                    variant="h4"
                                    fontWeight="bold"
                                >
                                    {props?.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        opacity: .9,
                                        mt: 1,
                                    }}
                                >
                                    Gerencie notícias,
                                    destaques e conteúdos
                                    institucionais.
                                </Typography>

                            </Box>

                            <Chip
                                icon={<Article />}
                                label={
                                    noticia?.seccao
                                }
                                sx={{
                                    background:
                                        'rgba(255,255,255,.15)',
                                    color: '#fff',
                                    backdropFilter:
                                        'blur(10px)',
                                    fontWeight:
                                        'bold',
                                }}
                            />

                        </Stack>

                    </Card>

                    {/* ALERTS */}
                    {error && (
                        <Alert
                            severity="error"
                            sx={{ mb: 3 }}
                        >
                            {error}
                        </Alert>
                    )}

                    {success && (
                        <Alert
                            severity="success"
                            sx={{ mb: 3 }}
                        >
                            {success}
                        </Alert>
                    )}

                    <Grid container spacing={4}>

                        {/* FORM */}
                        <Grid item xs={12} lg={8}>

                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: 5,
                                    p: 4,
                                    boxShadow:
                                        '0 10px 40px rgba(0,0,0,.06)',
                                }}
                            >

                                {/* TIPO */}
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    mb={2}
                                >
                                    Tipo de publicação
                                </Typography>

                                <FormControl>

                                    <RadioGroup
                                        row
                                        value={
                                            noticia?.seccao
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    >

                                        <FormControlLabel
                                            name="seccao"
                                            value="Notícia"
                                            control={
                                                <Radio />
                                            }
                                            label="Notícia"
                                        />

                                        <FormControlLabel
                                            name="seccao"
                                            value="Destaque"
                                            control={
                                                <Radio />
                                            }
                                            label="Destaque"
                                        />

                                    </RadioGroup>

                                </FormControl>

                                {/* PDF */}
                                {noticia?.seccao ===
                                    'Destaque' && (

                                    <Box mt={3}>

                                        <Typography
                                            fontWeight="bold"
                                            mb={1}
                                        >
                                            Anexo PDF
                                        </Typography>

                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={
                                                <CloudUpload />
                                            }
                                        >
                                            Anexar PDF

                                            <input
                                                hidden
                                                accept="application/pdf"
                                                type="file"
                                                name="anexo"
                                                onChange={
                                                    handleChange
                                                }
                                            />

                                        </Button>

                                        {noticia?.anexo && (

                                            <Typography
                                                variant="body2"
                                                mt={1}
                                            >
                                                PDF anexado.
                                            </Typography>
                                        )}

                                    </Box>
                                )}

                                <Divider
                                    sx={{ my: 4 }}
                                />

                                {/* IMAGEM */}
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    mb={2}
                                >
                                    Imagem da notícia
                                </Typography>

                                {props?.noticia ? (

                                    <ImageNoticiaEdit
                                        foto={
                                            props
                                                ?.noticia
                                                ?.imagem
                                        }
                                        noticiaId={
                                            props
                                                ?.noticia
                                                ?._id
                                        }
                                        setEditarNoticia={
                                            props.setEditarNoticia
                                        }
                                    />

                                ) : (

                                    <Paper
                                        elevation={0}
                                        sx={{
                                            border:
                                                '2px dashed #d1d5db',
                                            borderRadius: 5,
                                            overflow:
                                                'hidden',
                                            transition:
                                                '.3s',

                                            '&:hover':
                                                {
                                                    borderColor:
                                                        '#85287e',
                                                }
                                        }}
                                    >

                                        <label
                                            htmlFor="imagem"
                                            style={{
                                                cursor:
                                                    'pointer',
                                            }}
                                        >

                                            {imagemPreview ? (

                                                <Box
                                                    sx={{
                                                        position:
                                                            'relative',
                                                    }}
                                                >

                                                    <img
                                                        src={
                                                            imagemPreview
                                                        }
                                                        alt="Preview"
                                                        style={{
                                                            width:
                                                                '100%',
                                                            height: 350,
                                                            objectFit:
                                                                'cover',
                                                            display:
                                                                'block',
                                                        }}
                                                    />

                                                    <Box
                                                        sx={{
                                                            position:
                                                                'absolute',
                                                            inset: 0,
                                                            background:
                                                                'rgba(0,0,0,.25)',
                                                            opacity: 0,
                                                            transition:
                                                                '.3s',

                                                            '&:hover':
                                                                {
                                                                    opacity: 1,
                                                                }
                                                        }}
                                                    />

                                                </Box>

                                            ) : (

                                                <Stack
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    spacing={
                                                        2
                                                    }
                                                    sx={{
                                                        py: 10,
                                                        px: 3,
                                                    }}
                                                >

                                                    <Image
                                                        sx={{
                                                            fontSize: 70,
                                                            color:
                                                                '#85287e',
                                                        }}
                                                    />

                                                    <Typography
                                                        variant="h6"
                                                        fontWeight="bold"
                                                    >
                                                        Adicionar
                                                        imagem
                                                    </Typography>

                                                    <Typography
                                                        color="text.secondary"
                                                        align="center"
                                                    >
                                                        Recomendado:
                                                        1000x650px
                                                    </Typography>

                                                </Stack>
                                            )}

                                            <input
                                                hidden
                                                accept="image/png,image/jpeg,image/jpg"
                                                type="file"
                                                name="imagem"
                                                id="imagem"
                                                onChange={
                                                    handleChange
                                                }
                                            />

                                        </label>

                                    </Paper>
                                )}

                                <Divider
                                    sx={{ my: 4 }}
                                />

                                {/* CAMPOS */}
                                <Stack spacing={3}>

                                    <TextField
                                        label="Título"
                                        name="titulo"
                                        fullWidth
                                        required
                                        value={
                                            noticia?.titulo
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />

                                    <TextField
                                        label="Subtítulo"
                                        name="subTitulo"
                                        fullWidth
                                        multiline
                                        rows={2}
                                        value={
                                            noticia?.subTitulo
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />

                                    <TextField
                                        label="Categoria"
                                        name="categoria"
                                        select
                                        fullWidth
                                        value={
                                            noticia?.categoria
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    >

                                        {categorias.map(
                                            (
                                                categoria
                                            ) => (
                                                <MenuItem
                                                    key={
                                                        categoria
                                                    }
                                                    value={
                                                        categoria
                                                    }
                                                >
                                                    {
                                                        categoria
                                                    }
                                                </MenuItem>
                                            )
                                        )}

                                    </TextField>

                                    <TextField
                                        label="Fonte"
                                        name="fonte"
                                        fullWidth
                                        value={
                                            noticia?.fonte
                                        }
                                        onChange={
                                            handleChange
                                        }
                                        InputProps={{
                                            startAdornment:
                                                (
                                                    <Public
                                                        sx={{
                                                            mr: 1,
                                                            color:
                                                                'text.secondary',
                                                        }}
                                                    />
                                                )
                                        }}
                                    />

                                    <TextField
                                        label="Link da Fonte"
                                        name="link"
                                        type="url"
                                        fullWidth
                                        value={
                                            noticia?.link
                                        }
                                        onChange={
                                            handleChange
                                        }
                                        InputProps={{
                                            startAdornment:
                                                (
                                                    <LinkIcon
                                                        sx={{
                                                            mr: 1,
                                                            color:
                                                                'text.secondary',
                                                        }}
                                                    />
                                                )
                                        }}
                                    />

                                </Stack>

                            </Card>

                        </Grid>

                        {/* SIDEBAR */}
                        <Grid item xs={12} lg={4}>

                            <Stack spacing={4}>

                                {/* STATUS */}
                                <Card
                                    elevation={0}
                                    sx={{
                                        borderRadius: 5,
                                        p: 3,
                                        boxShadow:
                                            '0 10px 40px rgba(0,0,0,.05)',
                                    }}
                                >

                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        mb={2}
                                    >
                                        Estado da publicação
                                    </Typography>

                                    <FormControl>

                                        <RadioGroup
                                            value={
                                                noticia?.status
                                            }
                                            onChange={
                                                handleChange
                                            }
                                        >

                                            <FormControlLabel
                                                name="status"
                                                value="Activo"
                                                control={
                                                    <Radio />
                                                }
                                                label="Publicar"
                                            />

                                            <FormControlLabel
                                                name="status"
                                                value="Inactivo"
                                                control={
                                                    <Radio />
                                                }
                                                label="Guardar como rascunho"
                                            />

                                        </RadioGroup>

                                    </FormControl>

                                </Card>

                                {/* AÇÕES */}
                                <Card
                                    elevation={0}
                                    sx={{
                                        borderRadius: 5,
                                        p: 3,
                                        boxShadow:
                                            '0 10px 40px rgba(0,0,0,.05)',
                                    }}
                                >

                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        mb={3}
                                    >
                                        Acções
                                    </Typography>

                                    <Stack spacing={2}>

                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            startIcon={
                                                <Preview />
                                            }
                                            onClick={() =>
                                                setPreview(
                                                    true
                                                )
                                            }
                                        >
                                            Preview
                                        </Button>

                                        <Button
                                            fullWidth
                                            variant="contained"
                                            startIcon={
                                                loading
                                                    ? (
                                                        <CircularProgress
                                                            size={
                                                                18
                                                            }
                                                            color="inherit"
                                                        />
                                                    )
                                                    : (
                                                        <Save />
                                                    )
                                            }
                                            disabled={
                                                !noticia?.titulo ||
                                                !noticia?.imagem ||
                                                !noticia?.conteudo
                                            }
                                            sx={{
                                                background:
                                                    '#85287e',

                                                '&:hover':
                                                    {
                                                        background:
                                                            '#6f1d69',
                                                    }
                                            }}
                                            onClick={
                                                handleSubmit
                                            }
                                        >
                                            Salvar notícia
                                        </Button>

                                        <Button
                                            fullWidth
                                            color="error"
                                            variant="text"
                                            startIcon={
                                                <ArrowBack />
                                            }
                                            onClick={
                                                fecharFormulario
                                            }
                                        >
                                            Cancelar
                                        </Button>

                                    </Stack>

                                </Card>

                            </Stack>

                        </Grid>

                    </Grid>

                    {/* EDITOR */}
                    <Card
                        elevation={0}
                        sx={{
                            mt: 4,
                            borderRadius: 5,
                            p: 4,
                            boxShadow:
                                '0 10px 40px rgba(0,0,0,.06)',
                        }}
                    >

                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            mb={3}
                        >
                            Conteúdo da notícia
                        </Typography>

                        <Editor
                            setEditorData={
                                setNoticia
                            }
                            editorData={
                                noticia?.conteudo
                            }
                        />

                    </Card>

                </Box>

            ) : (

                // PREVIEW
                <Box>

                    <Card
                        elevation={0}
                        sx={{
                            mb: 3,
                            borderRadius: 4,
                            p: 2,
                            display: 'flex',
                            justifyContent:
                                'space-between',
                            alignItems: 'center',
                        }}
                    >

                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                        >

                            <IconButton
                                color="error"
                                onClick={() =>
                                    setPreview(
                                        false
                                    )
                                }
                            >
                                <Close />
                            </IconButton>

                            <Typography
                                variant="h6"
                                fontWeight="bold"
                            >
                                Preview da notícia
                            </Typography>

                        </Stack>

                        <Chip
                            label="Modo Preview"
                            color="secondary"
                        />

                    </Card>

                    <ViewNoticia
                        preview={noticia}
                        criacao={true}
                    />

                </Box>
            )}

        </>
    );
}